import React from 'react'
import { GET_REPORTS, GET_REPORT_BY_REPORT_OBJECT } from 'requests'
import './ReportsList.scss'
import DownloadIcon from '@tecuity/sos-icons/build/react-icons/download-box'
import format from 'date-fns/format'
import FileDownloader from 'components/FormManager/FileDownloader'
import { Spinner } from 'components/Loaders/Loaders'
import {noop} from 'utilities'

export default class ConnectedReportsList extends React.Component{
  state = {reports: [], loading: null}
  componentDidMount = () => {
    this.getReports()
  }
  componentDidUpdate = prevProps => {
    if (
      this.props.formDefinitionId !== prevProps.formDefinitionId ||
      this.props.amendmentNum !== prevProps.amendmentNum
    ) {
      if (!this.props.amendmentNum) {
        this.setState({ loading: null })
      } else {
        this.getReports()
      }
    }
  }
  getReports = () => {
    if(this.props.formDefinitionId && this.props.amendmentNum && this.props.amendmentNum !== "N/A"){
      this.setState({loading: true})
      const requestId = this.props.amendmentNum
      GET_REPORTS(this.props.formDefinitionId, this.props.amendmentNum, (reports => {
        if(requestId === this.props.amendmentNum){
          this.setState({reports: !reports || !Array.isArray(reports) ? [] : reports, loading: false})
        }
      }))
    }
    else{
      this.setState({reports: [], loading: null})
    }
  }
  render(){
    return(
      this.state.loading !== null ?
        this.state.loading ?
        <div className="reports-spinner animated fadeIn">
          <Spinner size="medium" themeColor="secondary" />
        </div>
        :
        <ReportsList id={this.props.id} loading={this.state.loading} reports={this.state.reports}/>
      : (
        <div className='reports-list'>
          <h5>No available downloads</h5>
        </div>
      )
    )
  }
}

const ReportsList = ({loading, reports, id}) => (
  <div className='reports-list'>
    <h5>{reports.length > 0 ? 'Available Downloads:' : 'No available downloads'}</h5>
    {
      !loading &&
      reports.map((report, i) => (
        <Report report={report} id={id} key={id + i} delay={50 * i} />
      ))
    }
  </div>
)

const DOWNLOAD_ERROR = `Something went wrong while downloading this file. Try again later.`

export class Report extends React.Component{
  state = {blob: null, downloading: false, fresh: true, rawBlob: null, downloadError: false}
  getDownload = () => {
    this.setState({downloading: true, downloadError: false, fresh: false})
    GET_REPORT_BY_REPORT_OBJECT(
      this.props.report,
      res => {
        if(res.ok){
          if(this.props.report.RETURN_TYPE === "URL"){
            res.text().then(url => {
              this.setState({
                blob: url,
                downloading: false,
                downloadError: false
              }, () => {
                this.downloader.download();
              })
            })
          }else{
            res.blob().then(blob => {
              const blobObject = window.URL.createObjectURL(blob);
              this.setState({blob: blobObject, rawBlob: blob, downloading: false, downloadError: false}, () => {
                this.downloader.download()
              })
            })
          }
        }else{
          this.setState({downloadError: true, downloading: false})
        }
      }, err => {
        this.setState({downloadError: true, downloading: false})
      })
  }
  render(){
    const { delay, report, animated, id=Date.now() } = this.props;
    const { REPORT_NAME='', LAST_MODIFIED_DATE } = report
    const hasExtension = REPORT_NAME.split('.').length >= 2
    return(
      <button className={`report ${animated !== false ? 'animated fadeInUp extra-fast-animation' : ''} ${this.state.downloadError ? 'error' : ''}`} style={{
        animationDelay: `${delay}ms`
      }} onClick={this.state.downloading ? noop : this.getDownload}>
        {/* <div className='shine'/> */}
        <div className='download-icon'>
          {
            this.state.downloading &&
            <div className='shine-spinner'/>
          }
          <DownloadIcon className={`icon ${this.state.fresh ? '' : this.state.downloading ? 'spin-out' : 'spin-in'}`}/>
        </div>
        <div className='labels'>
          <p style={{opacity: this.state.downloadError ? 1 : 0}} className="download-error" aria-hidden={true}>{DOWNLOAD_ERROR}</p>
          <span>{REPORT_NAME}</span>
          <span className='date'>{format(new Date(LAST_MODIFIED_DATE), 'MM/dd/yyyy')}</span>
          <p role="alert" className="visually-hidden">{this.state.downloadError ? DOWNLOAD_ERROR : ""}</p>
        </div>
        <FileDownloader
          ref={downloader => {
            this.downloader = downloader
          }}
          href={this.state.blob}
          blob={this.state.rawBlob}
          fileName={hasExtension ? REPORT_NAME : `${REPORT_NAME}${id ? `_${id}` : ''}.pdf`}
        />
      </button>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/MyWorkQueue/ReportsList.js